module.exports = __webpack_public_path__ + "images/logo-provincia-blanco.svg";


//////////////////
// WEBPACK FOOTER
// ./images/logo-provincia-blanco.svg
// module id = 42
// module chunks = 1